import type {QuestionInputType} from '@Components/event-wizard/event-wizard-ticketing/event-wizard-ticketing.types';

export const TICKETING_QUESTION_TYPE_PANEL_ID = 'Ticketing_Question_Type_Panel_ID';
export const TICKETING_QUESTION_TYPE_LIST_ID = 'TicketingQuestionTypeListID';

export interface TicketingQuestionTypeDropdownProps {
  value: QuestionInputType;
  onChange: (type: QuestionInputType) => void;
}
